// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CinematicController from "./cinematic_controller"
application.register("cinematic", CinematicController)

import DayTabsController from "./day_tabs_controller"
application.register("day-tabs", DayTabsController)

import DecadeBarController from "./decade_bar_controller"
application.register("decade-bar", DecadeBarController)

import HeaderController from "./header_controller"
application.register("header", HeaderController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ImageLightboxController from "./image_lightbox_controller"
application.register("image-lightbox", ImageLightboxController)

import ImageUploadController from "./image_upload_controller"
application.register("image-upload", ImageUploadController)

import ShotTabsController from "./shot_tabs_controller"
application.register("shot-tabs", ShotTabsController)

import SwiperController from "./swiper_controller"
application.register("swiper", SwiperController)

import VideoModalController from "./video_modal_controller"
application.register("video-modal", VideoModalController)
